 
import FalconCardHeader from '@/components/common/FalconCardHeader';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import { Button, Card, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { CSSProperties, ReactNode } from 'react';

type TreeSkeletonProps = {
  height?: CSSProperties['height'];
  title?: ReactNode;
};

const TreeSkeleton = ({ height, title }: TreeSkeletonProps) => (
  <Card className="my-2">
    <FalconCardHeader
      title={
        <div>
          {title}
          <HelpTooltip html="درحال بارگذاری" />
        </div>
      }
      titleTag="h6"
      className="py-3"
      light
    />
    <Card.Body className="py-2 my-2 position-relative">
      <div
        style={{ height }}
        className="d-flex align-items-center justify-content-center"
      >
        <Spinner />
      </div>
      <div className="position-absolute d-flex flex-column top-0 mt-3">
        <div className="rounded-3 bg-body-tertiary border-400 w-100 border">
          <Button
            variant="link"
            size="sm"
            className="bg-100 d-flex align-items-center justify-content-center rounded-bottom-0 p-2 text-700"
          >
            <FontAwesomeIcon icon="plus" className="fs--1" />
          </Button>
          <hr className="m-0 text-300" />
          <Button
            variant="link"
            size="sm"
            className="bg-100 d-flex align-items-center justify-content-center rounded-top-0  p-2 text-700"
          >
            <FontAwesomeIcon icon="undo-alt" className="fs--1" />
          </Button>
          <hr className="m-0 text-300" />
          <Button
            variant="link"
            size="sm"
            className="bg-100 d-flex align-items-center justify-content-center rounded-top-0  p-2 text-700"
          >
            <FontAwesomeIcon icon="minus" className="fs--1" />
          </Button>
        </div>
        <div className="bg-body-tertiary mt-3">
          <div className="bg-body-tertiary mt-1 ">
            <Button
              variant="link"
              size="sm"
              className="bg-100 d-flex align-items-center justify-content-center rounded-3 border border-400 w-100 p-2 text-700"
            >
              <FontAwesomeIcon
                icon={
                  document.fullscreenElement
                    ? 'compress-arrows-alt'
                    : 'expand-arrows-alt'
                }
                className="fs--1"
              />
            </Button>
          </div>
        </div>
        <div className="bg-body-tertiary mt-1 ">
          <Button
            variant="link"
            size="sm"
            className="bg-100 d-flex align-items-center justify-content-center rounded-3 border border-400 w-100  p-2 text-700"
          >
            <FontAwesomeIcon icon="text-height" className="fs--1" />
          </Button>
        </div>
        <div className="bg-body-tertiary mt-1 ">
          <Button
            variant="link"
            size="sm"
            className="bg-100 d-flex align-items-center justify-content-center rounded-3 border border-400 w-100  p-2 text-700"
          >
            <FontAwesomeIcon icon="save" className="fs--1" />
          </Button>
        </div>
      </div>
    </Card.Body>
  </Card>
);
export default TreeSkeleton;
